import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/lukas/Sites/git/own-packages/react-form-package/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Form, Button, Field, Select, RadioGroup } from '../src';
import { Playground } from 'docz';
import { data as checkboxData } from './data/checkboxes';
import { data as selectData } from './data/select';
import { data as radioData } from './data/radio';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "dynamic-fields"
    }}>{`Dynamic Fields`}</h1>
    <p>{`Sometimes you need to create your `}<inlineCode parentName="p">{`Form`}</inlineCode>{` out of dynamic data, e.g. from data you received from a server. This is mostly the case when using `}<inlineCode parentName="p">{`checkboxes`}</inlineCode>{`, `}<inlineCode parentName="p">{`radio groups`}</inlineCode>{`, or `}<inlineCode parentName="p">{`select fields`}</inlineCode>{`.`}</p>
    <p>{`For example: you could receive the data from the server and than use `}<inlineCode parentName="p">{`setState`}</inlineCode>{` to set the data for your `}<inlineCode parentName="p">{`checkboxes`}</inlineCode>{`, `}<inlineCode parentName="p">{`radio groups`}</inlineCode>{`, and `}<inlineCode parentName="p">{`select fields`}</inlineCode>{` used in your `}<inlineCode parentName="p">{`<Form />`}</inlineCode>{` component.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`async componentDidMount() {
  const response = await getDataFromServer();

  this.setState({
    checkboxData: response.data.checkboxData,
    selectData: response.data.selectData,
    radioData: response.data.radioData,
  });
}
`}</code></pre>
    <p>{`Than in your render function you would return something like:`}</p>
    <Playground __position={0} __code={'<Form>\n  <div>\n    {checkboxData.map(checkbox => (\n      <React.Fragment>\n        <div>{checkbox.name}</div>\n        <Field id={checkbox.id} type=\"checkbox\" />\n      </React.Fragment>\n    ))}\n  </div>\n  <div>\n    <Select type=\"select\" id=\"select\">\n      <option disabled value=\"\">\n        --- Select an option ---\n      </option>\n      {selectData.map(selectOption => (\n        <option value={selectOption.value}>{selectOption.name}</option>\n      ))}\n    </Select>\n  </div>\n  <div>\n    <RadioGroup type=\"radio\" id=\"radioID\">\n      {radioData.map(radioOption => (\n        <div>\n          <div>{radioOption.name}</div>\n          <input type=\"radio\" name=\"radioID\" id={radioOption.id} />\n        </div>\n      ))}\n    </RadioGroup>\n  </div>\n  <div>\n    <Button\n      type=\"submit\"\n      id=\"submit\"\n      onClick={state => {\n        alert(JSON.stringify(state, null, 2))\n        alert(\'open the console to see the whole state...\')\n        console.log(state)\n      }}\n    >\n      Submit\n    </Button>\n  </div>\n</Form>'} __scope={{
      props,
      DefaultLayout,
      Form,
      Button,
      Field,
      Select,
      RadioGroup,
      Playground,
      checkboxData,
      selectData,
      radioData
    }} mdxType="Playground">
  <Form mdxType="Form">
    <div>
      {checkboxData.map(checkbox => <React.Fragment>
          <div>{checkbox.name}</div>
          <Field id={checkbox.id} type="checkbox" mdxType="Field" />
        </React.Fragment>)}
    </div>
    <div>
      <Select type="select" id="select" mdxType="Select">
        <option disabled value="">
          --- Select an option ---
        </option>
        {selectData.map(selectOption => <option value={selectOption.value}>{selectOption.name}</option>)}  
      </Select>
    </div>
    <div>
      <RadioGroup type="radio" id="radioID" mdxType="RadioGroup">
        {radioData.map(radioOption => <div>
            <div>{radioOption.name}</div>
            <input type="radio" name="radioID" id={radioOption.id} />
          </div>)}  
      </RadioGroup>
    </div>
    <div>
      <Button type="submit" id="submit" onClick={state => {
            alert(JSON.stringify(state, null, 2));
            alert('open the console to see the whole state...');
            console.log(state);
          }} mdxType="Button">
        Submit
      </Button>
    </div>
  </Form>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      